import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import FlattenPDFImageListScreen from "./FlattenPDFImageListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function FlattenPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Flatten PDF For Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/flatten_pdf", title: "Uneditable PDF" },
    data2: { link: "/flatten_pdf", title: "Merge PDF Layers" },
    data3: { link: "/flatten_pdf", title: "Flatten PDF File Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Flatten PDF online instantly. Merge layers, secure forms, and convert interactive PDFs into static files quickly with our easy PDF flatten tool."
      ></meta>
      <meta
        name="keywords"
        content="flatten PDF, PDF flatten tool, flatten PDF online, merge PDF layers, secure PDF forms, convert PDF to static, interactive PDF to PDF, PDF editor online, PDF management tool, compress PDF layers, flatten interactive PDF, PDF file optimizer, online PDF flatten, PDF document tool, flatten PDF forms"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <FlattenPDFImageListScreen title={title}></FlattenPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Flatten PDF Offline website offers a secure, fast, and reliable solution to flatten PDF files both offline and online, making your documents permanent, non-editable, and ready for sharing or submission. Designed for professionals, students, and businesses, this powerful tool allows you to convert interactive PDFs into static files by merging layers, annotations, form fields, and comments into a single fixed layout. With offline functionality, all PDF flattening is processed directly on your device, ensuring complete privacy without uploading files to external servers. When internet access is available, users can also flatten PDF online using a smooth, browser-based interface for quick results. Whether you need to flatten PDF form fields before submitting official documents or lock annotations and signatures, this tool guarantees accurate output without altering the original appearance. The platform supports flatten PDF online for free, allowing users to process documents easily without complex setup or subscriptions. Using advanced flattening technology, the tool preserves text clarity, formatting, and visual integrity while preventing further edits. Compatible with desktop and mobile devices, this website helps you flatten PDF free, secure finalized documents, and ensure compatibility with government portals, job applications, and business workflows. If you are searching for the best flatten PDF offline tool, flatten PDF online, flatten PDF online for free, flatten PDF free, or an efficient way to flatten PDF form files securely, this platform delivers a complete, user-friendly, and privacy-first PDF solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Flatten",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Flatten PDF Tool"
            why_use={[
              {
                title: "Make PDFs Final and Non-Editable",
                description:
                  "Flattening PDFs converts interactive elements into a fixed layout, making documents non-editable and final. A flatten PDF tool ensures your files are ready for official submission and sharing.",
              },
              {
                title: "Secure Form Data and Signatures",
                description:
                  "When you flatten PDF form files, all filled fields, checkboxes, and digital signatures become permanent, preventing accidental changes or data loss.",
              },
              {
                title: "Improve Compatibility Across Devices",
                description:
                  "Some PDF viewers do not support layers or form elements properly. Using flatten PDF online ensures documents open and display correctly on all devices and platforms.",
              },
              {
                title: "Preserve Layout and Formatting",
                description:
                  "Flattening merges layers, annotations, and comments into one layer, maintaining the original layout. A flatten PDF online for free tool prevents formatting issues.",
              },
              {
                title: "Avoid Errors During Online Submissions",
                description:
                  "Many government portals and job application sites require static PDFs. Using a flatten PDF free solution helps avoid upload rejections caused by editable content.",
              },
              {
                title: "Protect Sensitive Information",
                description:
                  "Flattening locks the content in place, reducing the risk of unauthorized edits. A flatten PDF offline tool adds an extra level of document security.",
              },
              {
                title: "Ensure Accurate Printing Results",
                description:
                  "Flattened PDFs print exactly as they appear on screen. Using a flatten PDF form tool ensures all annotations and filled data appear correctly in printouts.",
              },
              {
                title: "Simplify Sharing and Collaboration",
                description:
                  "When sharing finalized documents, a flatten PDF online tool ensures recipients view the content as intended without modifying it.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Flattening PDFs removes the need for repeated checks and revisions. A fast flatten PDF free tool speeds up document processing.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "What does flattening a PDF mean?",
                description:
                  "Flattening a PDF combines certain interactive elements, such as form fields and annotations, with the page content to make the document's appearance more consistent. The exact result depends on which elements the flattening tool supports.",
              },
              {
                title: "How can I flatten a PDF online for free?",
                description:
                  "Open the Flatten PDF tool on ShivaPDF.com, select your PDF document, and start the flattening process. When processing is complete, download the flattened PDF to your device.",
              },
              {
                title: "Can I flatten a PDF without uploading my file?",
                description:
                  "If ShivaPDF processes your document entirely in your browser, you can flatten the PDF without uploading its contents to a remote server. Local processing can help protect the privacy of confidential documents.",
              },
              {
                title: "Can I flatten a PDF offline?",
                description:
                  "Offline PDF flattening is possible when the tool and all required resources are available locally on your device. If the website needs to load its processing components from the internet, you may need an internet connection before using the tool.",
              },
              {
                title: "Is it safe to flatten a PDF locally?",
                description:
                  "Local PDF processing can help protect document privacy because the file does not need to be sent to a remote server. For sensitive documents, verify that the tool performs all processing locally before using it.",
              },
              {
                title: "Why should I flatten a PDF?",
                description:
                  "Flattening a PDF can help preserve the appearance of form fields, annotations, and other supported elements when sharing, printing, or viewing a document in different PDF readers. It can also prevent flattened elements from being edited independently.",
              },
              {
                title: "Does flattening a PDF make it non-editable?",
                description:
                  "Flattening can make supported interactive elements, such as form fields and annotations, part of the page content so they cannot be edited independently in the usual way. It does not necessarily prevent all editing of the PDF or protect the document from modification.",
              },
              {
                title: "Does flattening a PDF remove form fields?",
                description:
                  "Flattening typically converts supported interactive form fields into their visible page appearance. The field values may remain visible, but the fields may no longer be interactive or editable as form controls.",
              },
              {
                title: "Can I flatten a PDF with filled forms?",
                description:
                  "Yes, a compatible flattening tool can make filled form fields part of the visible PDF page content. Review the output to confirm that all entered information appears correctly before sharing or printing the document.",
              },
              {
                title: "Does flattening a PDF remove annotations and comments?",
                description:
                  "Flattening may convert supported annotations and comments into visible page content. The annotations may no longer be independently selectable or editable after flattening, depending on the tool and annotation type.",
              },
              {
                title: "Will flattening a PDF preserve its original layout?",
                description:
                  "Flattening is generally intended to preserve the document's visible appearance, including text, images, form values, and supported annotations. Results may vary depending on the PDF structure and the elements being flattened.",
              },
              {
                title: "Does flattening a PDF reduce its file size?",
                description:
                  "Flattening does not always reduce PDF file size. The resulting file may be smaller, similar in size, or larger depending on the document's content and how interactive elements are converted into page content.",
              },
              {
                title: "Can I flatten a scanned PDF?",
                description:
                  "A scanned PDF can often be processed if it is supported by the flattening tool, although it may not contain interactive fields or annotations to flatten. Flattening a scanned document does not automatically perform OCR or make its text searchable.",
              },
              {
                title: "Can I flatten a password-protected PDF?",
                description:
                  "Password-protected PDFs may require the correct password before they can be processed. Support depends on the PDF's security settings and the capabilities of the flattening tool.",
              },
              {
                title: "Can I flatten a PDF on my phone?",
                description:
                  "You can access ShivaPDF.com from a supported mobile browser on an iPhone, Android phone, or tablet. Whether flattening works on your device depends on browser compatibility, document size, and available memory.",
              },
              {
                title: "Do I need to install software to flatten a PDF?",
                description:
                  "You do not need a separate desktop application when using a browser-based PDF flattening tool. Open ShivaPDF.com in a supported browser, select your document, and follow the available steps.",
              },
              {
                title: "Can I flatten multiple PDF files at once?",
                description:
                  "Batch flattening is available only if the tool supports processing multiple PDF files in one operation. Check the Flatten PDF page for the current file selection and processing options.",
              },
              {
                title: "Will flattening a PDF affect digital signatures?",
                description:
                  "Modifying a digitally signed PDF can invalidate its existing signature or affect signature validation. If the document contains a digital signature, keep an untouched original and check the signature requirements before flattening.",
              },
              {
                title: "Can I undo PDF flattening?",
                description:
                  "Flattening may permanently remove the independent interactivity of supported fields and annotations in the resulting file. Keep a copy of the original PDF if you may need to edit those elements later.",
              },
              {
                title: "How do I download a flattened PDF?",
                description:
                  "After the flattening process finishes, select the download option to save the resulting PDF to your device. Open the downloaded document and verify that its appearance and required information are correct.",
              },
              {
                title: "Why should I use ShivaPDF to flatten a PDF?",
                description:
                  "ShivaPDF offers browser-based PDF tools to help you manage documents without installing separate desktop software. Use the Flatten PDF tool to prepare supported PDF forms and annotations for sharing, viewing, or printing.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default FlattenPDFMain;
